import { useEffect, useState } from 'react';
import { Alert, Autocomplete, Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { filtrarClientes, etiquetaCliente } from './clienteSearch';
import { fetchClientesComercial, useComercialContext } from './ComercialContext';
import { isSuccess } from '../common/domain/RemoteData.model';
import { useUserContext } from '../user/infrastructure/UserContext';

const ComercialBanner = () => {
    const { actingAsCliente, setActingAsCliente, clearActingAsCliente, agente, setAgente } = useComercialContext();
    const user = useUserContext();
    const [clientes, setClientes] = useState([]);
    // Con varios agentes, el comercial elige con cuál sale el pedido (obligatorio); con uno, no hay nada que elegir
    const agentes = user?.salespersonCodes || [];
    const debeElegirAgente = agentes.length > 1 && user?.eligeAgente !== false;

    useEffect(() => {
        fetchClientesComercial().then(result => {
            if (isSuccess(result)) setClientes(result.value);
        });
    }, []);

    return (
        <Alert severity="warning" sx={{ borderRadius: 0, alignItems: 'center' }} icon={false}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="body2" fontWeight="bold">
                    Modo comercial
                </Typography>
                {user?.almacen && (
                    <Typography variant="body2" sx={{ px: 1, borderRadius: 1, bgcolor: '#b71c1c', color: 'white', fontWeight: 'bold' }}
                                title="Tus pedidos salen de este almacén y el stock que ves es el suyo">
                        Almacén: {user.almacen}
                    </Typography>
                )}
                {actingAsCliente ? (
                    <>
                        <Typography variant="body2">
                            Actuando como: <strong>{actingAsCliente.nombreRazonSocial}</strong>
                            {actingAsCliente.alias ? ` · ${actingAsCliente.alias}` : ''} ({actingAsCliente.numCliente})
                        </Typography>
                        <Button size="small" variant="outlined" color="warning" onClick={clearActingAsCliente}>
                            Cambiar cliente
                        </Button>
                        {debeElegirAgente && (
                            <FormControl size="small" error={!agente} sx={{ minWidth: 170, background: 'white', borderRadius: 1 }}
                                         title="Agente al que se repercute esta venta (campo Agente del pedido en BC)">
                                <InputLabel id="comercial-agente-label">Agente *</InputLabel>
                                <Select labelId="comercial-agente-label" label="Agente *" value={agente || ''}
                                        onChange={(e) => setAgente(e.target.value)}>
                                    {agentes.map(codigo => (
                                        <MenuItem key={codigo} value={codigo}>Agente {codigo}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                        {debeElegirAgente && !agente && (
                            <Typography variant="body2" color="error" fontWeight="bold">
                                Elige el agente para poder tramitar el pedido
                            </Typography>
                        )}
                    </>
                ) : (
                    <Autocomplete
                        options={clientes}
                        getOptionLabel={etiquetaCliente}
                        filterOptions={filtrarClientes}
                        isOptionEqualToValue={(a, b) => a.numCliente === b.numCliente}
                        onChange={(_, cliente) => { if (cliente) setActingAsCliente(cliente); }}
                        size="small"
                        sx={{ minWidth: 300, background: 'white', borderRadius: 1 }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Buscar por nombre, alias, nº o CIF..." />
                        )}
                    />
                )}
            </Box>
        </Alert>
    );
};

export default ComercialBanner;
